import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS } from "../data/site";

const FAQ = () => (
  <section
    id="faq"
    data-testid="faq"
    className="py-20 md:py-28 bg-[hsl(var(--background))]"
  >
    <div className="container-tjb grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-4">
        <p className="eyebrow">Helpful Info</p>
        <h2 className="h-section mt-3">Frequently Asked Questions</h2>
        <p className="mt-5 text-[hsl(var(--ink))]/75">
          Got more questions? Message us on WhatsApp — our team replies daily,
          9 AM to 9 PM.
        </p>
      </div>
      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              className="border-b border-[hsl(var(--border))]"
            >
              <AccordionTrigger
                data-testid={`faq-q-${i}`}
                className="text-left font-display text-lg md:text-xl py-5 hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-a-${i}`}
                className="text-[15px] text-[hsl(var(--ink))]/80 leading-relaxed pb-5 pr-6"
              >
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default FAQ;
